var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"text-3xl text-pink-900 font-medium mt-8 sm:mt-12 sm:text-4xl"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }